"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashPoleStatus = exports.DashPoleStatusConfig = exports.execHeaders = exports.statusHeaders = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var mobx_1 = require("mobx");
var icons_1 = require("../../components/icon/icons");
var modal_style_1 = require("../../components/modal/modal.style");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var photomeasure_button_1 = require("../../modules/photomeasure.button/photomeasure.button");
var services_1 = require("../../services");
var page_1 = require("../page");
var dashboard_banner_1 = require("./dashboard.banner");
var dashboard_style_1 = require("./dashboard.style");
var dashboard_table_1 = require("./dashboard.table");
var dashboard_table_style_1 = require("./dashboard.table.style");
// original status headers
// export enum statusHeaders {
//     'BACKLOG',
//     'NOT COLLECTED',
//     'COLLECTED',
//     'HOA COMPLETE',
//     'PLA COMPLETE',
//     'MRA',
//     'RECOLLECT',
//     'BILLED',
//     'DONE'
// }
//analyst status headers
var statusHeaders;
(function (statusHeaders) {
    statusHeaders[statusHeaders["PLANNING"] = 0] = "PLANNING";
    statusHeaders[statusHeaders["COLLECT"] = 1] = "COLLECT";
    statusHeaders[statusHeaders["ASSIGN"] = 2] = "ASSIGN";
    statusHeaders[statusHeaders["LOCATION"] = 3] = "LOCATION";
    statusHeaders[statusHeaders["HOA"] = 4] = "HOA";
    statusHeaders[statusHeaders["MEAS QA"] = 5] = "MEAS QA";
    statusHeaders[statusHeaders["PLA"] = 6] = "PLA";
    statusHeaders[statusHeaders["MRE"] = 7] = "MRE";
    statusHeaders[statusHeaders["FINAL QA"] = 8] = "FINAL QA";
    statusHeaders[statusHeaders["DELIVERY"] = 9] = "DELIVERY";
    statusHeaders[statusHeaders["ACCEPTANCE"] = 10] = "ACCEPTANCE";
    statusHeaders[statusHeaders["BILLING"] = 11] = "BILLING";
    statusHeaders[statusHeaders["DONE"] = 12] = "DONE";
    statusHeaders[statusHeaders["REWORK"] = 13] = "REWORK";
})(statusHeaders || (exports.statusHeaders = statusHeaders = {}));
//exec status headers
var execHeaders;
(function (execHeaders) {
    execHeaders[execHeaders["PLANNING"] = 0] = "PLANNING";
    execHeaders[execHeaders["IKE FIELD"] = 1] = "IKE FIELD";
    execHeaders[execHeaders["IKE OFFICE"] = 2] = "IKE OFFICE";
    execHeaders[execHeaders["QA"] = 3] = "QA";
    execHeaders[execHeaders["DELIVERY"] = 4] = "DELIVERY";
    execHeaders[execHeaders["DONE"] = 5] = "DONE";
    execHeaders[execHeaders["REWORK"] = 6] = "REWORK";
})(execHeaders || (exports.execHeaders = execHeaders = {}));
//this need to be in the same order as the header enums
var headerMap = {
    PLANNING: 'PLANNING',
    COLLECT: 'IKE FIELD',
    ASSIGN: 'IKE OFFICE',
    LOCATION: 'IKE OFFICE',
    HOA: 'IKE OFFICE',
    'MEAS QA': 'IKE OFFICE',
    PLA: 'IKE OFFICE',
    MRE: 'IKE OFFICE',
    'FINAL QA': 'QA',
    DELIVERY: 'DELIVERY',
    ACCEPTANCE: 'DELIVERY',
    BILLING: 'DELIVERY',
    DONE: 'DONE',
    REWORK: 'REWORK'
};
exports.DashPoleStatusConfig = {
    type: 'internal',
    name: page_1.IkePageName.dashboardPolestatus,
    path: '/dashboard/pole_status',
    auth: {
        required: true,
        tokens: [core_api_1.IkeToken.DASHBOARD_PAGE]
    },
    nav: {
        name: i18n_1.T.DASHBOARD,
        icon: icons_1.MaterialIcon.DASHBOARD
    },
    layout: { nav: false, banner: true }
};
var DashPoleStatus = /** @class */ (function (_super) {
    tslib_1.__extends(DashPoleStatus, _super);
    function DashPoleStatus() {
        var _this = _super.call(this, exports.DashPoleStatusConfig) || this;
        _this.poleStatusSum = null;
        _this.execView = true; //starts off in executive view
        return _this;
    }
    DashPoleStatus.prototype.init = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, services_1.Services.Dashboard.getPoleStatusSummary()];
                    case 1:
                        _a.poleStatusSum = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(DashPoleStatus.prototype, "nodes", {
        get: function () {
            var node = null;
            if (!(services_1.Services.Token.has(core_api_1.IkeToken.DASHBOARD_PAGE))) {
                node = (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.container }, (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.message }, 'No Dashboard Token'));
                return node;
            }
            if (this.poleStatusSum == null) {
                this.init();
            }
            node = (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.container }, [
                dashboard_banner_1.DashBanner.nodes,
                this.viewTable()
            ]);
            return node;
        },
        enumerable: false,
        configurable: true
    });
    DashPoleStatus.prototype.toggleView = function () {
        this.execView = !this.execView;
    };
    DashPoleStatus.prototype.getTableView = function () {
        return this.execView;
    };
    DashPoleStatus.prototype.viewTable = function () {
        var _this = this;
        var rows = [];
        var poleStatTotal = [];
        var execPoleStatTotal = [];
        //zeroing out the totals aggregation arrays to be the length of the table headers
        //enums aren't easily iterable so they have to become objects first.
        for (var i = 0; i < (Object.keys(execHeaders).filter(function (k) { return typeof execHeaders[k] === 'number'; })).length; i++) {
            execPoleStatTotal[i] = 0;
        }
        for (var i = 0; i < (Object.keys(statusHeaders).filter(function (k) { return typeof statusHeaders[k] === 'number'; })).length; i++) {
            poleStatTotal[i] = 0;
        }
        //make sure we have data
        if (this.poleStatusSum != null) {
            var index_1 = 0;
            this.poleStatusSum.forEach(function (el) {
                if (el != null) {
                    var jobName = el.jobName == null ? 'NULL' : el.jobName;
                    var jobId = el.jobId == null ? '' : el.jobId;
                    if (el.collectionStatusSummary != null) {
                        var poleStat_1 = [];
                        var execPoleStat_1 = [];
                        //zeroing out the row aggregation arrays to be the length of the table headers
                        for (var i = 0; i < (Object.keys(execHeaders).filter(function (k) { return typeof execHeaders[k] === 'number'; })).length; i++) {
                            execPoleStat_1[i] = 0;
                        }
                        for (var i = 0; i < (Object.keys(statusHeaders).filter(function (k) { return typeof statusHeaders[k] === 'number'; })).length; i++) {
                            poleStat_1[i] = 0;
                        }
                        el.collectionStatusSummary.forEach(function (col) {
                            if (col != null) {
                                if (col.collections != null && col.status != null) {
                                    // enum[enum_string] returns the place of that string in the enum
                                    // sorts the collection counts into the correct columns for exec and analyst views
                                    execPoleStat_1[execHeaders[headerMap[_this.cleanStatus(col.status)]]] += col.collections;
                                    execPoleStatTotal[execHeaders[headerMap[_this.cleanStatus(col.status)]]] += col.collections;
                                    poleStat_1[statusHeaders[_this.cleanStatus(col.status)]] += col.collections;
                                    poleStatTotal[statusHeaders[_this.cleanStatus(col.status)]] += col.collections;
                                }
                            }
                        });
                        //only show jobs that had at least some non null data
                        if (poleStat_1.reduce(function (a, b) { return a + b; }, 0) > 0) {
                            index_1++;
                            rows.push(_this.viewRow(index_1, jobId, jobName, _this.execView ? execPoleStat_1 : poleStat_1));
                        }
                    }
                }
            });
            //add the totals row to the top of the table
            rows.unshift(this.viewTotals(this.execView ? execPoleStatTotal : poleStatTotal));
            return dashboard_table_1.Table.view(this.viewTitle(), this.viewHeaders(), rows);
        }
        return (0, mithril_1.m)('div', {
            className: dashboard_style_1.CSS.message
        }, 'No Data Available');
    };
    DashPoleStatus.prototype.viewTitle = function () {
        var _this = this;
        //the title also has a button to switch between views
        return (0, mithril_1.m)('div', { className: dashboard_table_style_1.CSS.title }, [
            (0, mithril_1.m)('h6', {}, 'POLE STATUS'),
            (0, mithril_1.m)('button', {
                className: modal_style_1.MDL.button,
                onclick: function (ev) { _this.toggleView(); }
            }, this.execView ? 'EXEC' : 'ANALYST')
        ]);
    };
    DashPoleStatus.prototype.viewHeaders = function () {
        var headers = [];
        headers.push('#');
        headers.push('JOB NAME');
        if (this.execView) {
            var execH = Object.keys(execHeaders).filter(function (k) { return typeof execHeaders[k] === 'number'; });
            for (var i = 0; i < execH.length; i++) {
                headers.push(execH[i]);
            }
        }
        else {
            var statH = Object.keys(statusHeaders).filter(function (k) { return typeof statusHeaders[k] === 'number'; });
            for (var i = 0; i < statH.length; i++) {
                headers.push(statH[i]);
            }
        }
        headers.push('TOTAL');
        return headers;
    };
    DashPoleStatus.prototype.viewTotals = function (totals) {
        var columns = [];
        columns.push((0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, '-'));
        columns.push((0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, 'TOTALS:'));
        for (var i = 0; i < totals.length; i++) {
            columns.push((0, mithril_1.m)('span', {
                className: ((this.execView ? 'execHeader' + i % 2 : 'execHeader' + (execHeaders[headerMap[statusHeaders[i]]] % 2)))
            }, totals[i] ? totals[i] : 0));
        }
        columns.push((0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, totals.reduce(function (a, b) { return a + b; }, 0)));
        return columns;
    };
    DashPoleStatus.prototype.viewRow = function (index, id, name, cols) {
        var columns = [];
        columns.push((0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, index));
        columns.push((0, mithril_1.m)('div', { className: dashboard_style_1.CSS.tableCellRoleActions }, [
            (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.tableCell }, name),
            (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.tableCellGhost }, photomeasure_button_1.PhotomeasureButton.view(id))
        ])); //jobname
        //iterates through the columns
        for (var i = 0; i < cols.length; i++) {
            columns.push((0, mithril_1.m)('span', {
                className: ((this.execView ? 'execHeader' + i % 2 : 'execHeader' + (execHeaders[headerMap[statusHeaders[i]]] % 2)))
            }, cols[i] ? cols[i] : 0));
        }
        //adds up everything for the total column
        columns.push((0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, cols.reduce(function (a, b) { return a + b; }, 0)));
        return columns;
    };
    DashPoleStatus.prototype.cleanStatus = function (status) {
        if (status != null) {
            var cleanStat = status.toUpperCase().trim();
            return cleanStat;
        }
        return '';
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], DashPoleStatus.prototype, "poleStatusSum", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], DashPoleStatus.prototype, "execView", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], DashPoleStatus.prototype, "viewTable", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], DashPoleStatus.prototype, "viewTitle", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], DashPoleStatus.prototype, "viewHeaders", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], DashPoleStatus.prototype, "viewRow", null);
    return DashPoleStatus;
}(page_1.IkePage));
exports.DashPoleStatus = DashPoleStatus;
//# sourceMappingURL=pole.status.page.js.map